import React, { ReactElement } from 'react';
import { Alert, DatePickerDateValue, Spinner } from '@odin-labs/components';
import { CheckIcon } from 'components/icons';

export function ImportScheduleModalPreview({
  date,
  jobsiteName,
  shiftCount,
  isLoading,
  isScheduleFound,
}: {
  date?: DatePickerDateValue;
  jobsiteName?: string;
  shiftCount?: number;
  isLoading?: boolean;
  isScheduleFound?: boolean;
}): ReactElement {
  if (!date) {
    return null;
  }

  if (isLoading) {
    return <Spinner size="base" className="odin-text-odin-primary" />;
  }

  if (!isScheduleFound) {
    return (
      <Alert
        text={`No schedules found on ${date.format(
          'MM/DD/YYYY',
        )} for ${jobsiteName}`}
      />
    );
  }

  return (
    <Alert
      type="success"
      icon={CheckIcon}
      text={`The ${date.format('MM/DD/YYYY')} schedule has ${shiftCount} ${
        shiftCount === 1 ? 'shift' : 'shifts'
      } that will be imported`}
    />
  );
}
